module.exports = __webpack_public_path__ + "static/media/canada_day (8 of 2).491e3089.jpg";